import React, { useState, useRef, useEffect } from "react";

import { toSafeFilename } from "../../../helpers";
import FilePlus from "../../../utils/icons/FilePlus";

export default function OpDefault({
  valid,
  labelButton,
  message,
  onSubmit,
}: {
  valid: boolean;
  labelButton?: string;
  message: string;
  onSubmit: Function;
}) {
  const [newFilename, setNewFilename] = useState(null);
  const filenameInput = useRef(null);

  useEffect(() => {
    if (valid) {
      setTimeout(() => {
        filenameInput.current.focus();
      }, 50);
    }
  }, [valid]);

  return valid ? (
    <>
      <div className="center">↓</div>
      <input
        key="input"
        type="text"
        className="block fz08 mt1"
        name="filename"
        placeholder="Enter a filename"
        onChange={(e) => setNewFilename(e.target.value)}
        ref={filenameInput}
      />
      <div className="center mt1">
        <button
          className="secondary"
          disabled={!newFilename}
          onClick={() =>
            onSubmit({
              filename: toSafeFilename(newFilename),
            })
          }
        >
          {labelButton}
        </button>
      </div>
    </>
  ) : (
    <p className="mb1 mt1 tac fz08 with-icon">
      <FilePlus size={16} className="ib" /> {message}
    </p>
  );
}
